import { JobType } from '../../constants';
import { createTableSlice } from '../helpers';

export const tableSlice = createTableSlice({
  name: 'automatedJobs/autolabelTable',
  url: '/api/jobs',
  filters: {
    type: JobType.AUTOLABEL,
  },
  sortOrder: 'desc',
  orderBy: 'id',
});
